module.exports = __webpack_public_path__ + "img/beand21_375.9d5d22b3.png";